import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import StorageService from '../services/StorageService';
import { ToggleIcon } from '../assets/icons';
import '../styles/SettingsSidebar.css';

const SettingsSidebar = ({ onSettingsChange }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [settings, setSettings] = useState({
    language: 'English',
    standard: '',
    subject: '',
    method: ''
  });

  useEffect(() => {
    const savedSettings = StorageService.getSettings();
    if (savedSettings) {
      setSettings(savedSettings);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newSettings = { ...settings, [name]: value };
    setSettings(newSettings);
    StorageService.saveSettings(newSettings);
    if (onSettingsChange) {
      onSettingsChange(newSettings);
    }
  };

  return (
    <div className={`settings-sidebar ${isOpen ? 'open' : 'closed'}`}>
      <button 
        className="toggle-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? 'Close settings' : 'Open settings'}
      >
        <ToggleIcon isOpen={isOpen} />
      </button>
      
      <div className="settings-content">
        <h5>Settings</h5>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Language</Form.Label>
            <Form.Select
              name="language"
              value={settings.language}
              onChange={handleChange}
            >
              <option value="English">English</option>
              <option value="Hindi">Hindi</option>
              <option value="Gujarati">Gujarati</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Standard</Form.Label>
            <Form.Select
              name="standard"
              value={settings.standard}
              onChange={handleChange}
            >
              <option value="">Choose Standard</option>
              <option value="std1">Standard 1</option>
              <option value="std2">Standard 2</option>
              <option value="std3">Standard 3</option>
              <option value="std4">Standard 4</option>
              <option value="std5">Standard 5</option>
              <option value="std6">Standard 6</option>
              <option value="std7">Standard 7</option>
              <option value="std8">Standard 8</option>
              <option value="std9">Standard 9</option>
              <option value="std10">Standard 10</option>
              <option value="std11">Standard 11</option>
              <option value="std12">Standard 12</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Subject</Form.Label>
            <Form.Select
              name="subject"
              value={settings.subject}
              onChange={handleChange}
            >
              <option value="">Choose Subject</option>
              <option value="math">Mathematics</option>
              <option value="science">Science</option>
              <option value="gujarati">Gujarati</option>
              <option value="english">English</option>
              <option value="social">Social Science</option>
              <option value="physics">Physics</option>
              <option value="chemistry">Chemistry</option>
              <option value="biology">Biology</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Method</Form.Label>
            <Form.Select
              name="method"
              value={settings.method}
              onChange={handleChange}
            >
              <option value="">Choose Method</option>
              <option value="qa">Question & Answer</option>
              <option value="essay">Essay</option>
              <option value="experiment">Experiment</option>
              <option value="mathExample">Math Example</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
};

export default SettingsSidebar;
